module.exports = __webpack_public_path__ + "img/new_bee.6b5ee35a.png";